<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        title="CustomerOrder"
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet class="mx-3">
          <v-tabs show-arrows>
            <v-tab>Detail</v-tab>
            <v-tab-item>
              <CommonHTMXComponent :iframe-src="'/production/customer_order/detail/' + uidItem + '/?disable_top=true'" :height="height - 30" class="mx-0 my-0 px-0 py-0"></CommonHTMXComponent>
            </v-tab-item>

            <v-tab>BOM</v-tab>
            <v-tab-item>
              <v-row class="mt-0">
                <v-col cols="7">
                  <v-row>
                    <v-icon
                        v-if="storeAggregate.rootData[storeDetail.uidItem].notion_id != null"
                        color="primary"
                        size="20"
                        @click="onNotion(storeAggregate.rootData[storeDetail.uidItem])"
                        class="ml-3"
                    >
                      mdi-alpha-n-box-outline
                    </v-icon>
                    <v-chip label outlined class="mt-2 mx-3">{{
                        storeAggregate.rootData[storeDetail.uidItem].name
                      }}
                    </v-chip>
                    <v-chip-group v-model="productOrderPoint" mandatory @change="onProductChange">
                      <v-chip
                          v-for="productOrderUid in storeAggregate.rootData[storeDetail.uidItem].product_orders_uid"
                          v-if="storeAggregate.rootData[productOrderUid].deleted === false"
                          outlined
                          filter
                      >
                        {{ storeAggregate.rootData[productOrderUid].name }}
                      </v-chip>
                    </v-chip-group>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="2">
                  <CommonFieldString
                      v-if="!!storeAggregate && !!storeAggregate.rootData &&
                          !!productOrderUid &&
                          !!storeAggregate.rootData[productOrderUid]"
                      v-model="storeAggregate.rootData[productOrderUid].article_number"
                      outlined
                      label="Product article"
                      dense
                      class="mt-n2 mb-n6"
                      readonly=""
                      @click:prepend="onProductOrderClick(productOrderUid)"
                      prepend-icon="mdi-file-edit-outline"
                  >
                  </CommonFieldString>
                </v-col>
<!--                <v-col cols="1">-->
<!--                  <CommonFieldString-->
<!--                      v-if="!!storeAggregate && !!storeAggregate.rootData &&-->
<!--                          !!productOrderUid &&-->
<!--                          !!storeAggregate.rootData[productOrderUid]"-->
<!--                      v-model="storeAggregate.rootData[productOrderUid].panasonic_product"-->
<!--                      outlined-->
<!--                      label="Panasonic product"-->
<!--                      dense-->
<!--                      :clearable="true"-->
<!--                      class="mt-n2 mb-n6"-->
<!--                  >-->
<!--                  </CommonFieldString>-->
<!--                </v-col>-->
                <v-col cols="1">
                  <CommonFieldString
                      v-if="!!storeAggregate && !!storeAggregate.rootData && storeAggregate.rootData[storeDetail.uidItem]"
                      v-model="storeAggregate.rootData[storeDetail.uidItem].lot_size"
                      readonly
                      label="Batch size"
                      class="mt-n2 mb-n6"
                      filled
                  ></CommonFieldString>
                </v-col>
                <v-col cols="2">
                  <CommonFieldString
                      v-if="!!storeAggregate && !!storeAggregate.rootData &&
                    storeAggregate.rootData[storeDetail.uidItem].customer_uid &&
                    storeAggregate.rootData[storeAggregate.rootData[storeDetail.uidItem].customer_uid]"
                      v-model="storeAggregate.rootData[storeAggregate.rootData[storeDetail.uidItem].customer_uid].name"
                      outlined
                      label="Customer"
                      dense
                      :readonly="true"
                      class="mt-n2 mb-n6"
                      filled
                  >
                  </CommonFieldString>
                </v-col>
              </v-row>
              <v-sheet class="mt-4" v-if="!!currentItem(productOrderUid)">
                <v-tabs class="mt-n6" v-if="!!currentItem(productOrderUid)">
                  <v-tab>Import&Match</v-tab>
                  <v-tab-item>
                    <CoreBomMatchTable :product_order_uid="productOrderUid"
                                       :height="height-40"></CoreBomMatchTable>
                  </v-tab-item>
                  <v-tab>Match Check</v-tab>
                  <v-tab-item>
                    <CoreBomMainAttrTable :product_order_uid="productOrderUid"
                                          :height="height-40"></CoreBomMainAttrTable>
                  </v-tab-item>
                  <v-tab>BOM</v-tab>
                  <v-tab-item>
                    <CoreBomImportCheckTable :product_order_uid="productOrderUid"
                                             :height="height-40"></CoreBomImportCheckTable>
                  </v-tab-item>
                  <v-tab>Panasonic</v-tab>
                  <v-tab-item>
                    <CoreBomPanasonicTable :product_order_uid="productOrderUid"
                                           :height="height-40"></CoreBomPanasonicTable>
                  </v-tab-item>
                  <v-tab>Pick & Place</v-tab>
                  <v-tab-item>
                    <CoreProductOrderPickPlaceTable :product_order_uid="productOrderUid"
                                                    :height="height-40"></CoreProductOrderPickPlaceTable>
                  </v-tab-item>
                  <v-tab>BOM-DGS Compare</v-tab>
                  <v-tab-item>
                    <CommonHTMXComponent :iframe-src="'/component/bom_dgs_compare/' + productOrderUid + '/'"
                                         :height="height - 190"></CommonHTMXComponent>
                  </v-tab-item>
                </v-tabs>
              </v-sheet>
            </v-tab-item>

            <v-tab>
              <span style="white-space: nowrap;">Product order</span>
            </v-tab>
            <v-tab-item>
              <v-container fluid>
                <CommonHTMXComponent :iframe-src="'/production/po_br_detail/' + productOrderCalculateUid + '/?disable_top=true'" :height="height - 30" class="mx-0 my-0 px-0 py-0"></CommonHTMXComponent>
              </v-container>
            </v-tab-item>

            <v-tab
                :disabled="!storeDetail.uidItem || !storeAggregate.rootData[storeDetail.uidItem] ||
                !storeAggregate.rootData[storeDetail.uidItem].customer_uid"
            >Material delivery
            </v-tab>
            <v-tab-item>
              <MaterialDeliveryTable
                  title="Material delivery"
                  dtoListQuery="MaterialDeliveryListQueryDTO"
                  :store-name="storeMaterialDeliveryTableName"
                  :detail-store-name="storeMaterialDeliveryDetailName"
                  :height="customerOrderHeight - 200"
                  :embedded="true"
                  :headers="materialDeliveryHeaders"
              >
                <template v-slot:top>{{ '' }}</template>
                <template
                    v-slot:footer.prepend
                    v-if="currentItem.is_group"
                >{{ '' }}
                </template>
              </MaterialDeliveryTable>
            </v-tab-item>

            <v-tab
                :disabled="!storeDetail.common.data || storeDetail.common.data.batch_run_list.length === 0 || !storeDetail.common.data.batch_run_uid">
              <span style="white-space: nowrap;">Material flow</span>
              <CoreBatchRunReservationStatus
                  v-if="!!storeDetail.common.data"
                  :value="storeDetail.common.data.batch_run_list"></CoreBatchRunReservationStatus>
            </v-tab>
            <v-tab-item>
              <v-row class="py-3">
                <v-col cols="2">
                  <v-checkbox
                      v-if="!!storeDetail.common.data.batch_run_uid && !!storeAggregate.rootData[storeDetail.common.data.batch_run_uid]"
                      v-model="storeAggregate.rootData[storeDetail.common.data.batch_run_uid].in_production"
                      class="mt-0"
                      label="In production"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="4">
                  <CommonFieldSelect
                      v-if="!!storeDetail.common.data"
                      v-model="storeDetail.common.data.batch_run_uid"
                      item-text="name"
                      item-value="uid"
                      :items="storeDetail.common.data.batch_run_list"
                  >
                  </CommonFieldSelect>
                </v-col>
                <v-col cols="2">
                  <CommonFieldString
                      v-if="!!storeDetail.common.data.batch_run_uid"
                      v-model="storeAggregate.rootData[storeDetail.common.data.batch_run_uid].status"
                      label="Status"
                  >
                  </CommonFieldString>
                </v-col>
                <v-col cols="1">
                  <CommonFieldString
                      v-if="!!storeDetail.common.data.batch_run_uid"
                      v-model="storeAggregate.rootData[storeDetail.common.data.batch_run_uid].lot_size_smd"
                      label="SMD"
                  >
                  </CommonFieldString>
                </v-col>
                <v-col cols="1">
                  <CommonFieldString
                      v-if="!!storeDetail.common.data.batch_run_uid"
                      v-model="storeAggregate.rootData[storeDetail.common.data.batch_run_uid].lot_size_tht"
                      label="THT"
                  >
                  </CommonFieldString>
                </v-col>
                <v-col cols="2">
                  <CommonFieldString
                      v-if="!!storeDetail.common.data.batch_run_uid"
                      v-model="storeAggregate.rootData[storeDetail.common.data.batch_run_uid].delivery_date"
                      label="Delivery date"
                  >
                  </CommonFieldString>
                </v-col>
              </v-row>
              <v-tabs show-arrows>
                <v-tab>Check & Reserve</v-tab>
                <v-tab-item>
                  <BatchRunComponentTable
                      title="BatchRunComponent"
                      dtoListQuery="BatchRunComponentListQueryDTO"
                      :store-name="storeBatchRunComponentTableName"
                      :detail-store-name="storeBatchRunComponentDetailName"
                      :height="customerOrderHeight - 340"
                      :embedded="true"
                      :selected-batch-run-uid="storeDetail.common.data.batch_run_uid"
                  >
                  </BatchRunComponentTable>
                </v-tab-item>
                <v-tab>Material List</v-tab>
                <v-tab-item>
                  <MaterialReservationTable
                      title="MaterialReservation"
                      :headers="headersMaterialReservation"
                      dtoListQuery="MaterialReservationListQueryDTO"
                      :store-name="storeMaterialReservationTableName"
                      :detail-store-name="storeMaterialReservationDetailName"
                      :height="customerOrderHeight - 340"
                      :embedded="true"
                      :qrcode="'bat-' + storeDetail.common.data.batch_run_uid"
                      :selected-batch-run-uid="storeDetail.common.data.batch_run_uid"
                  >
                  </MaterialReservationTable>
                </v-tab-item>
                <v-tab>QA logs</v-tab>
                <v-tab-item>
                  <!--                        :iframe-src="'/component/quality_control_list/' + uidItem + '/'"-->
                  <CommonHTMXComponent
                      :iframe-src="'/component/quality_control_list/'"
                      :height="height - 210"></CommonHTMXComponent>
                </v-tab-item>
              </v-tabs>
            </v-tab-item>

            <v-tab>
              <span style="white-space: nowrap;">BatchRuns</span>
            </v-tab>
            <v-tab-item>
              <v-container fluid>
                <CommonHTMXComponent :iframe-src="'/production/batchrun/?disable_top=true&customer_order_uid=' + uidItem" :height="height - 30" class="mx-0 my-0 px-0 py-0"></CommonHTMXComponent>
              </v-container>
            </v-tab-item>

            <v-tab :disabled="!locationUid">Locations</v-tab>
            <v-tab-item>
              <v-chip v-if="!!storeAggregate.rootData && !!locationUid">
                {{ storeAggregate.rootData[locationUid].name }}
              </v-chip>
              <MaterialLocationTable
                  title="Locations in the CustomerOrder"
                  dtoListQuery="MaterialLocationInListQueryDTO"
                  :store-name="storeLocationInCustomerOrderTableName"
                  :height="customerOrderHeight / 2 - 220"
                  :parent-uid="locationUid"
              >
                <template v-slot:top>{{ '' }}</template>
              </MaterialLocationTable>
              <MaterialLocationTable
                  title="Location out the CustomerOrder"
                  dtoListQuery="MaterialLocationOutListQueryDTO"
                  :store-name="storeLocationOutCustomerOrderTableName"
                  :height="customerOrderHeight / 2 - 160"
              >
              </MaterialLocationTable>
            </v-tab-item>

          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CoreBomMatchTable from "@/components/CoreComponent/ProductOrder/CoreBomMatchTable";
import CoreBomMainAttrTable from "@/components/CoreComponent/ProductOrder/CoreBomMainAttrTable";
import CoreBomPanasonicTable from "@/components/CoreComponent/ProductOrder/CoreBomPanasonicTable";
import CoreProductOrderPickPlaceTable from "@/components/CoreComponent/ProductOrder/CoreProductOrderPickPlaceTable";
import MaterialDeliveryTable from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryTable";
import {useTableStore} from "@/components/Common/CommonTable";
import {v4 as uuidv4} from "uuid";
import BatchRunComponentTable from "@/components/CoreComponent/BatchRunComponent/BatchRunComponentTable";
import CoreBomImportCheckTable from "@/components/CoreComponent/ProductOrder/CoreBomImportCheckTable";
import CommonFieldSelect from "@/components/Common/CommonFieldSelect";
import MaterialReservationTable from "@/components/CoreMaterial/MaterialReservation/MaterialReservationTable";
import CoreBatchRunReservationStatus from "@/components/CoreComponent/BatchRun/CoreBatchRunReservationStatus";
import MaterialLocationTable from "@/components/CoreMaterial/MaterialLocation/MaterialLocationTable.vue";
import CommonHTMXComponent from "@/components/Common/CommonHTMXComponent.vue";
import {defineAsyncComponent} from "vue";

export default {
  name: "CustomerOrderDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'CustomerOrderDetail'},
    dtoDetailQuery: {default: 'CustomerOrderDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CustomerOrderActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'CustomerOrderSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'CustomerOrderValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'CustomerOrderBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CustomerOrderTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonHTMXComponent,
    BaseFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
    CommonSelectFromTable,
    CommonFieldString,
    CoreBomMatchTable,
    CoreBomMainAttrTable,
    CoreBomPanasonicTable,
    CoreProductOrderPickPlaceTable,
    MaterialDeliveryTable,
    BatchRunComponentTable,
    CoreBomImportCheckTable,
    CommonFieldSelect,
    MaterialReservationTable,
    CoreBatchRunReservationStatus,
    MaterialLocationTable,
  },

  computed: {
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    customerOrderHeight() {
      if (this.modalDialog) {
        return this.$vuetify.breakpoint.height * 0.90 - 39
      } else {
        return this.$vuetify.breakpoint.height - 39
      }
    },
    batchRunUid() {
      if (!!this.storeDetail && !!this.storeDetail.common && !!this.storeDetail.common.data)
        return this.storeDetail.common.data.batch_run_uid
      else return null
    },
    locationUid() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && this.storeDetail.uidItem &&
          !!this.storeAggregate.rootData[this.storeDetail.uidItem])
        return this.storeAggregate.rootData[this.storeDetail.uidItem].location_uid
    },

    productOrderCalculateUid() {
        if (!!this.storeAggregate && !!this.storeAggregate.rootData && this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid) {
        return this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid[0]
      } else
        return null
      },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        console.log('watch BomDetail uidItem', newValue, oldValue)
        if (!!this.storeAggregate && !!this.storeAggregate.rootData && this.storeDetail.uidItem &&
            !!this.storeAggregate.rootData[this.storeDetail.uidItem] &&
            !!this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid) {
          this.productOrderUid = this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid[0]
        } else {
          this.productOrderUid = null
        }
        this.customerOrderFilter()
        this.filterBatchRunComponent()
        this.filterMaterialReservation()
        this.filterLocationInCustomerOrderTable()
        this.filterLocationOutCustomerOrderTable()
        this.storeMaterialDeliveryDetail.parentUid = this.storeDetail.uidItem
      },
      deep: true
    },
    batchRunUid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterBatchRunComponent()
        this.filterMaterialReservation()
      },
      deep: true
    },
    locationUid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterLocationInCustomerOrderTable()
        this.filterLocationOutCustomerOrderTable()
      },
      deep: true
    },
  },

  methods: {
    onProductOrderClick(productOrderUid) {
      if (!!productOrderUid) {
        const routeData = this.$router.resolve({name: 'CoreProductOrderDetail', params: {uidItem: productOrderUid}});
        window.open(routeData.href, '_blank');
      }
    },
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    currentItem(product_order_uid) {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && product_order_uid)
        return this.storeAggregate.rootData[product_order_uid]
      else
        return null
    },
    onProductChange(event) {
      // console.log('onProductChange', event)
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid) {
        this.productOrderUid = this.storeAggregate.rootData[this.storeDetail.uidItem].product_orders_uid[event]
      } else
        this.productOrderUid = null
      this.filterBatchRunComponent()
      this.filterMaterialReservation()
    },
    filterBatchRunComponent() {
      if (!!this.storeBatchRunComponentTable) {
        this.storeBatchRunComponentTable.query_filters = {
          and_concat: true,
          filter_list: [
            {param_compare: 'batch_run__uid', value: this.batchRunUid,},
            // {param_compare: 'deleted', value: false,},
          ],
          enable: true,
        }
      }
    },
    filterMaterialReservation() {
      if (!!this.storeMaterialReservationTable) {
        this.storeMaterialReservationTable.query_filters = {
          and_concat: true,
          filter_list: [
            {param_compare: 'batchrun_component__batch_run__uid', value: this.batchRunUid,},
            // {param_compare: 'deleted', value: false,},
          ],
          enable: true,
        }
      }
    },
    customerOrderFilter() {
      this.storeMaterialDeliveryTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'customer_order__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },

    filterLocationInCustomerOrderTable() {
      this.storeLocationInCustomerOrderTable.uidItem = this.storeDetail.uidItem
      let location_uid = this.locationUid || uuidv4()
      this.storeLocationInCustomerOrderTable.query_filters = {
        and_concat: false,
        filter_list: [
          {param_compare: 'parent__uid', value: location_uid},
        ],
        enable: true,
      }
    },
    filterLocationOutCustomerOrderTable() {
      this.storeLocationOutCustomerOrderTable.uidItem = this.storeDetail.uidItem
      let location_uid = this.locationUid || uuidv4()
      this.storeLocationOutCustomerOrderTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'parent__uid', value: location_uid, negative: true},
          {param_compare: 'customerorder__isnull', value: true},
          {param_compare: 'parent__isnull', value: true},
        ],
        enable: true,
      }
    },
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()

    this.storeMaterialDeliveryTable = useTableStore(this.storeMaterialDeliveryTableName)()
    this.customerOrderFilter()
    this.storeMaterialDeliveryDetail = useDetailStore(this.storeMaterialDeliveryDetailName)()

    this.storeBatchRunComponentTable = useTableStore(this.storeBatchRunComponentTableName)()
    this.filterBatchRunComponent()

    this.storeMaterialReservationTable = useTableStore(this.storeMaterialReservationTableName)()
    this.filterMaterialReservation()

    this.storeLocationInCustomerOrderTable = useTableStore(this.storeLocationInCustomerOrderTableName)()
    this.filterLocationInCustomerOrderTable()
    this.storeLocationOutCustomerOrderTable = useTableStore(this.storeLocationOutCustomerOrderTableName)()
    this.filterLocationOutCustomerOrderTable()
  }
  ,

  data() {
    return {
      storeLocationInCustomerOrderTable: null,
      storeLocationInCustomerOrderTableName: uuidv4(),
      storeLocationOutCustomerOrderTable: null,
      storeLocationOutCustomerOrderTableName: uuidv4(),
      storeDetail: null,
      storeAggregate: null,
      productOrderUid: null,
      productOrderPoint: null,
      storeMaterialDeliveryTable: null,
      storeMaterialDeliveryTableName: uuidv4(),
      storeMaterialDeliveryDetail: null,
      storeMaterialDeliveryDetailName: uuidv4(),
      materialDeliveryHeaders: [
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
        {
          text: 'Registration material',
          value: 'registration',
          sortable: false,
          filterable: true,
          divider: true,
          width: 10
        },
        {text: 'Provider', value: 'provider__name', sortable: true, filterable: true, divider: true},
        {text: 'Material owner', value: 'material_owner__name', sortable: true, filterable: true, divider: true},
        {text: 'Delivery number', value: 'delivery_number', sortable: true, filterable: true, divider: true},
        {text: 'Mandatory PN', value: 'mandatory_pn', sortable: true, filterable: true, divider: true, type: 'bool'},
        {text: 'Opened', value: 'opened', sortable: true, filterable: true, divider: true, type: 'bool'},
        {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
      ],

      storeBatchRunComponentTableName: uuidv4(),
      storeBatchRunComponentTable: null,
      storeBatchRunComponentDetailName: uuidv4(),

      storeMaterialReservationTableName: uuidv4(),
      storeMaterialReservationTable: null,
      storeMaterialReservationDetailName: uuidv4(),

      headersMaterialReservation: [
        // {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Material', value: 'material__supply_type', sortable: true, filterable: true, divider: true},
        // {text: 'Full location', value: 'material__parent__location__name', sortable: true, filterable: true, divider: true},
        {
          text: 'Location',
          value: 'material__location__name',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Full location',
          value: 'material__location__fullname',
          sortable: false,
          filterable: true,
          divider: true,
          width: 200
        },
        {text: 'Article', value: 'material__component__article', sortable: true, filterable: true, divider: true},
        {text: 'Material UID', value: 'material_uid', sortable: true, filterable: true, divider: true},
        {text: 'Reservation quantity', value: 'quantity', sortable: true, true: true, divider: true},
        {text: 'Current QTY', value: 'material__current_qty', sortable: true, true: true, divider: true},

        {text: 'Batch start QTY', value: 'material__batch_start_qty', sortable: false, true: true, divider: true},
        {text: 'Min remaining QTY', value: 'material__min_remaining_qty', sortable: false, true: true, divider: true},
        {text: 'QTY delta', value: 'qty_delta', sortable: true, true: true, divider: true},

        {text: 'Lifecycle', value: 'material__lifecycle', sortable: true, filterable: true, divider: true, width: 200},

        {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      ],

    }
  }
  ,
}
</script>

<style scoped>

</style>